
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Article, ArticleService } from './../news/shared';
import { LanguageService } from '../core/language-resource/language.service';
import { Report, ReportOverview, ReportService } from "../reports/shared";
import { DynReportService, DynamicReportType } from "../dyn-reports/shared";
import { SurveyService } from "../surveys/shared/survey.services";
import { SurveyOverview } from "../surveys/shared/survey.model";

@Component({
  moduleId: module.id,
  selector: 'bp-dashboard',
  templateUrl: './dashboard.component.html',

})

export class DashboardComponent implements OnInit, OnDestroy {
  displayDialog: boolean;
  inFocusArticles: Article[];
  latestArticles: Article[];
  reports: DynamicReportType[];
  surveys: SurveyOverview[];

  constructor
    (
    private articleService: ArticleService,
    private reprotsService: ReportService,
    private dynReportService: DynReportService,
    private surveyService: SurveyService
    ) { }

  ngOnInit(): void {
    this.getInFocusArticles();
    this.getLatestArticles();
    this.getDynReports();
    this.getSurveys();
   // this.getStaticReports();
    //console.log('init dashborada');
    //throw new Error("Method not implemented.");
  }

  ngOnDestroy(): void {
    //console.log('destroy dashborada');
    //throw new Error("Method not implemented.");
  }

  getDynReports() {
    this.dynReportService.getReportsTypes()
      .subscribe((reports: DynamicReportType[]) => {
        //console.log('articles ', articles);
        this.reports = reports;
      });
  }

  getInFocusArticles() {
    this.articleService.getInFocusArticles()
      .subscribe((articles: Article[]) => {
       // console.log("=======>", articles);
        this.inFocusArticles = articles;
      });
  }

  getLatestArticles() {
    this.articleService.getLatestArticles()
      .subscribe((articles: Article[]) => {
        //console.log('articles ', articles);
        this.latestArticles = articles;
      });
  }

  getSurveys() {
    this.surveyService.getSurveys()
      .subscribe((surveys: SurveyOverview[]) => {
        this.surveys = surveys;
        //console.log('surveys', this.surveys);
      });
  }

  //getStaticReports() {
  //  this.reprotsService.getReports()
  //    .subscribe((reports: ReportOverview[]) => {
  //      //console.log('articles ', articles);
  //      this.reports = reports;
  //    });
  //}


  openDialog(event: Event) {
    event.preventDefault();
    this.displayDialog = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts